import { LOGIN_STUDIES, LOGIN_URL } from "../resources/ApiUrls";
import MyAxiosInstance from "../utils/MyAxiosInstance";

const login = (body) => MyAxiosInstance.post(LOGIN_URL, body);

const loginStudies = (body) => MyAxiosInstance.post(LOGIN_STUDIES, { ...body, remember_me: 0, slug: "a" });

const loginConsts = { login, loginStudies };

export default loginConsts;
